module.exports = __webpack_public_path__ + "img/disablesend.a1210c37.svg";